import * as React from 'react'

import notFoundImg from '../assets/illustrations/c3/404.png'
import accessDeniedImg from '../assets/illustrations/c3/access-denied.png'
import sessionTimeoutImg from '../assets/illustrations/c3/session-timeout.png'

/** Illustrations wired on login-ui error, timeout, and help screens. */
type ImgIllustrationProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  src: string
  alt?: string
}

const ImgIllustration = ({ src, alt = '', ...props }: ImgIllustrationProps): JSX.Element => (
  <img src={src} alt={alt} {...props} />
)

export const ForbiddenIllustration = (props: React.ImgHTMLAttributes<HTMLImageElement>): JSX.Element => (
  <ImgIllustration src={accessDeniedImg} alt="" {...props} />
)

export const ExpiredLinkIllustration = (props: React.ImgHTMLAttributes<HTMLImageElement>): JSX.Element => (
  <ImgIllustration src={sessionTimeoutImg} alt="" {...props} />
)

export const HelpIllustration = (props: React.ImgHTMLAttributes<HTMLImageElement>): JSX.Element => (
  <ImgIllustration src={notFoundImg} alt="" {...props} />
)
